import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pnc_ic_pnc",
  "use": "icon-pnc_ic_pnc-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pnc_ic_pnc\"><path clip-rule=\"evenodd\" d=\"m17.3 8.1c-.4-.1-.8-.1-1.3-.1-4.4 0-8 3.6-8 8 0 2.8 1.5 5.3 3.7 6.7 4.2-1 7.3-4.8 7.3-9.2 0-2-.6-3.9-1.7-5.4z\" fill=\"#d1f0c5\" fill-rule=\"evenodd\" /><g fill=\"#1a1a1a\"><path d=\"m12 23c-3.9 0-7-3.1-7-7v-10c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v10c0 3.9-3.1 7-7 7zm-5-17v10c0 2.8 2.2 5 5 5s5-2.2 5-5v-10z\" /><path d=\"m12.1 17.7c-.2 0-.3 0-.5-.1-.5-.3-.7-.9-.4-1.4l1.2-2.2h-2.5c-.4 0-.7-.2-.9-.5s-.2-.7 0-1l2.2-3.7c.3-.5.9-.6 1.4-.4.5.3.6.9.4 1.4l-1.4 2.2h2.5c.4 0 .7.2.9.5s.2.7 0 1l-2.1 3.7c-.1.3-.5.5-.8.5z\" /><path d=\"m9.6 5.8c-.6 0-1-.4-1-1v-2.4c0-.6.4-1 1-1s1 .4 1 1v2.4c0 .6-.4 1-1 1z\" /><path d=\"m14.4 5.8c-.6 0-1-.4-1-1v-2.4c0-.6.4-1 1-1s1 .4 1 1v2.4c0 .6-.4 1-1 1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pnc_ic_pnc.svg
// module id = wmT1
// module chunks = 87